import React, {useRef} from "react";
import ServiceCollection from "src/services/ServiceCollection";
import {Header, Tabs} from "@amzn/awsui-components-react/polaris";
import DefaultMappingSectionView from "src/components/ic-account-mapping/DefaultMappingSectionView";
import ActivityLogSectionView from "src/components/ic-account-mapping/ActivityLogSectionView";
import {useHistory, useLocation} from "react-router-dom";
import CONSTANTS from "src/utils/constants";
import {MANAGE_EXCEPTIONS_TAB_URL_PREFIX} from "src/components/ic-account-mapping/constants";
import ManageExceptionsSectionView from "src/components/ic-account-mapping/ManageExceptionsSectionView";
import moment from "moment";

export default function ICAccountMappingView(props: { services: ServiceCollection }) {
    const history = useHistory();
    const location = useLocation();
    const loadTime = useRef((new Date()).toString());
    const [openPeriod] = props.services.mecService.getHandOffStatus(loadTime.current);

    const getActiveTabId = () => {
        if (location.pathname.includes('manageExceptions')) return 'manageExceptions';
        if (location.pathname.includes('activityLog')) return 'activityLog';
        return 'defaultMapping';
    };

    return (
        <>
            <Header variant="h3">Changes will be effective from MEC reporting cycle: {openPeriod ?
                moment(openPeriod, CONSTANTS.PERIOD_VALUE_FORMAT).format('MMM-YY').toUpperCase() : null}</Header>
            <Tabs
                activeTabId={getActiveTabId()}
                onChange={({detail}) => {
                    history.push(detail.activeTabHref || "/icAccountMapping/defaultMapping");
                }}
                tabs={[
                    {
                        label: "Default Mapping",
                        id: "defaultMapping",
                        content: <DefaultMappingSectionView services={props.services}/>,
                        href: "/icAccountMapping/defaultMapping",
                    },
                    {
                        label: "Manage Exceptions",
                        id: "manageExceptions",
                        content: <ManageExceptionsSectionView services={props.services}/>,
                        href: MANAGE_EXCEPTIONS_TAB_URL_PREFIX
                    },
                    {
                        label: "Activity Log",
                        id: "activityLog",
                        content: <ActivityLogSectionView services={props.services}/>,
                        href: "/icAccountMapping/activityLog"
                    }
                ]}
            />
        </>
    )
}